import type { Ref } from "react";
import { useEffect, useRef } from "react";
import {
  getTransformRuleType,
  getTransformRuleTypeDisplayValue,
  isTransformRuleType,
  TransformRuleType,
} from "../../types/transformation/TransformationRuleTypes";
import { setRef } from "../../utils/SetRef";
import { useDropdown } from "../hooks/useDropdown";
import Icon from "../Icon";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { TTReplaceRuleLabel } from "../tooltips/ConfigurationTooltips";

import { Label, LabelProps } from "./Label";

export { TransformTypeLabel };
type Props = {
  /**
   * Current TransfromRule discriminator.
   */
  discriminator: TransformRuleType;
  onTypeChange(newType: TransformRuleType): void;
} & LabelProps;
/**
 * An <InputGroup/> label element that allows for the TransformType to be changed
 */
const TransformTypeLabel = ({
  ref,
  ...props
}: Props & {
  ref?: Ref<HTMLLabelElement>;
}) => {
  const containerRef = useRef<HTMLLabelElement | null>(null);

  const { isOpen, renderTooltip, setOpen, triggerBounds, triggerProps } =
    useDropdown({
      containerRef,
      options: getTransformRuleType().reduce((prev, curr) => {
        //@ts-expect-error
        prev[curr] = getTransformRuleTypeDisplayValue(
          curr as TransformRuleType,
        );
        return prev;
      }, {}),
      selected: props.discriminator,
      onSelect: (val) => {
        if (isTransformRuleType(val)) {
          props.onTypeChange(val);
        }
      },
    });

  return (
    <Label
      {...props}
      className={"dropdownLabel"}
      ref={(r) => {
        containerRef.current = r;
        setRef(ref, r);
      }}
    >
      {props.children}
      <Icon
        {...triggerProps}
        onClick={() => setOpen(!isOpen)}
        altText={"Change Type"}
        icon={"chevron-down"}
      />
      {isOpen && renderTooltip()}
    </Label>
  );
};
